import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import close_img from '../../assets/close.svg';
import gap_avatar from '../../assets/gap_avatar.svg';

export default function PictureModal(props) {
  const {
    src = '',
    onClose = () => { },
    zIndex = 200,
    canClose = true
  } = props;

  const [imageError, setImageError] = useState(false);

  const handleKeyPress = (evt) => {
    if (evt.keyCode == 27 && canClose) {
      onClose();
    }
  };

  const handleImageError = (e) => {
    e.target.src = gap_avatar;
    setImageError(true);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (src == undefined || src == '') {
    return;
  }

  return (
    <Wrapper zIndex={zIndex} onClick={onClose}>

      <Box onClick={e => e.stopPropagation()}>
        {canClose == false ? null :
          <TopBox>
            <CloseIcon alt={'close'} src={close_img} onClick={() => {
              onClose();
            }} />
          </TopBox>
        }

        <ContentPlaceholder>
          <Image alt={'picture'} src={src} onError={handleImageError} hasError={imageError} />
        </ContentPlaceholder>

      </Box>

    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  z-index: ${props => (props.zIndex == undefined ? 10 : props.zIndex)};
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(51, 51, 51, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
  cursor: pointer;
`;

const Box = styled.div`
  box-sizing: border-box;
  color: white;
  border-radius: 12px;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  
  max-width: min(calc(100vw - 48px), calc(100vh - 48px));
  max-height: min(calc(100vw - 48px), calc(100vh - 48px));
  width: fit-content;
  height: fit-content;
`;

const Image = styled.img`
  border-radius: 12px;
  max-height: 95vh;
  ${props => props.hasError && `
    opacity: 0.5;
    background: #131313;
  `}
`;

const TopBox = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;
`;

const CloseIcon = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;
  
  @media (max-width: 720px) {
    z-index: 11;
  }
`;

const ContentPlaceholder = styled.div`
  font-family: Nunito Sans !important;
`;
